import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Alert, Button } from 'reactstrap';
import { createSelector } from 'reselect';
import { useMatchedParams } from '../../../../slices/auth/settings/helper';
import { push } from 'redux-first-history';
import { toggleFontModal } from '../../../../slices/modals/reducer';

function FontWarning() {
  const params = useParams();
  const dispatch = useDispatch();
  const selectState = createSelector(state => state, state => ({
    fontNotUploaded: state.Campaign.fontNotUploaded,
    fontNotUploadedName: state.Campaign.fontNotUploadedName,
  }));
  const { fontNotUploaded, fontNotUploadedName } = useSelector(selectState);

  function openFonts() {
    // dispatch(push(`/${params.client}/${params.brand}/fonts`));
    dispatch(toggleFontModal());
  }

  return (
    <React.Fragment>
      {fontNotUploaded && fontNotUploadedName.length > 0 ?
        <Alert className='mb-3 d-flex align-items-center font-warning' color="danger">
          <p className='m-0'>
            <i class="ri-error-warning-line me-2 align-middle fs-17"></i>
            The fonts <b> {fontNotUploadedName[0]} </b> used in your creative set is not available in our system. This may cause your creatives to display with an incorrect font. Please select a different font or upload the required font to ensure accurate display.
          </p>
          <Button color='light' className='ms-auto me-0' style={{ whiteSpace: `nowrap` }} onClick={openFonts}>
            <i className='mdi mdi-format-font me-2 align-middle'></i>
            Manage fonts
          </Button>
        </Alert>
        : null}
    </React.Fragment>
  )
}

export default FontWarning
